import React from 'react';
import { Button, MenuItem, Paper, Stack, TextField } from '@mui/material';

/**
 * Magic Lamp — shared filter bar
 *
 * Used by both Analytics and the spin log so the two screens filter identically
 * and a filter learned on one works on the other.
 *
 * The quick ranges matter more than they look: "today" and "last 7 days" are
 * what someone actually wants during and just after an event, and making them
 * one click avoids fiddling with two date pickers on a busy day.
 */
function isoDaysAgo(days) {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString().slice(0, 10);
}

const today = () => new Date().toISOString().slice(0, 10);

export const QUICK_RANGES = [
  { label: 'Today', from: today, to: today },
  { label: 'Last 7 days', from: () => isoDaysAgo(6), to: today },
  { label: 'Last 30 days', from: () => isoDaysAgo(29), to: today },
  { label: 'All time', from: () => '', to: () => '' },
];

export default function Filters({ campaigns, filters, onChange, extra = null }) {
  const set = (patch) => onChange({ ...filters, ...patch });

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Stack direction="row" gap={2} flexWrap="wrap" alignItems="center">
        <TextField
          select
          size="small"
          label="Campaign"
          value={filters.campaignId || ''}
          onChange={(event) => set({ campaignId: event.target.value })}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">All campaigns</MenuItem>
          {campaigns.map((campaign) => (
            <MenuItem key={campaign.id} value={campaign.id}>
              {campaign.name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          size="small"
          type="date"
          label="From"
          InputLabelProps={{ shrink: true }}
          value={filters.from || ''}
          onChange={(event) => set({ from: event.target.value })}
        />
        <TextField
          size="small"
          type="date"
          label="To"
          InputLabelProps={{ shrink: true }}
          value={filters.to || ''}
          onChange={(event) => set({ to: event.target.value })}
        />

        <Stack direction="row" gap={0.5} flexWrap="wrap">
          {QUICK_RANGES.map((range) => (
            <Button
              key={range.label}
              size="small"
              variant={
                (filters.from || '') === range.from() && (filters.to || '') === range.to()
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => set({ from: range.from(), to: range.to() })}
            >
              {range.label}
            </Button>
          ))}
        </Stack>

        {extra}
      </Stack>
    </Paper>
  );
}
